import { render, staticRenderFns } from "./board_card.vue?vue&type=template&id=ccb3d084&"
import script from "./board_card.vue?vue&type=script&lang=js&"
export * from "./board_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports